import Vue from 'vue';
import Router from 'vue-router';
import NProgress from 'nprogress';
import 'nprogress/nprogress.css';
import store from './store.js';

Vue.use(Router);

let router = new Router({
  mode: 'history',
  routes: [
    {
      path: "*",
      meta: {
        public: true
      },
      redirect: {
        path: "/404"
      }
    },

    {
      path: "/404",
      meta: {
        public: true
      },
      name: "NotFound",
      component: () =>
        import(
          /* webpackChunkName: "routes" */
          `@/views/NotFound.vue`
        )
    },
    {
      path: "/mobil",
      meta: {
        public: true
      },
      name: "app_mobil",
      component: () =>
        import(
          /* webpackChunkName: "routes" */
          `@/views/app/Index.vue`
        )
    },
    {
      path: "/403",
      meta: {
        public: true
      },
      name: "AccessDenied",
      component: () =>
        import(
          /* webpackChunkName: "routes" */
          `@/views/Deny.vue`
        )
    },
    {
      path: "/500",
      meta: {
        public: true
      },
      name: "ServerError",
      component: () =>
        import(
          /* webpackChunkName: "routes" */
          `@/views/Error.vue`
        )
    },
    {
      path: "/reset/:id",
      meta: { public: true },
      name: "components/reset",
      component: () =>
        import(
          /* webpackChunkName: "routes" */
          `@/views/usuarios/Reset.vue`
        )
    },
    {
      path: "/",
      meta: {
        public: true,
        permissions: [
          {
            role: 0,
            access: true,
            redirect: 'login'
          },
          {
            role: 1,
            access: false,
            redirect: "home"
          },


        ]
      },
      name: "login",
      component: () =>
        import(
          /* webpackChunkName: "routes" */
          `@/views/usuarios/Login.vue`
        )
    },


    {
      path: "/home",
      meta: {
        //windowRedirectAfter: true,
        permissions: [
          {
            role: 0,
            access: false,
            redirect: 'login',
          },
          {
            role: 1,
            access: true,
          },

        ],
      },
      name: "home",
      component: () =>
        import(
          /* webpackChunkName: "routes" */
          `@/views/Home.vue`
        )
    },
    {
      path: "/administracion/empresas",
      meta: {
        permissions: [
          {
            role: 0,
            access: false,
            redirect: "login"
          },
          {
            role: 1,
            access: true,
          },
        ],
      },
      name: "empresas",
      component: () =>
        import(
          /* webpackChunkName: "routes" */
          `@/views/administracion/Empresas.vue`
        )
    },

    {
      path: "/administracion/pagos",
      meta: {
        permissions: [
          {
            role: 0,
            access: false,
            redirect: "login"
          },
          {
            role: 1,
            access: true,
          },
        ],
      },
      name: "pagosadmin",
      component: () =>
        import(
          /* webpackChunkName: "routes" */
          `@/views/administracion/Pagos.vue`
        )
    },
    {
      path: "/pagos",
      meta: {
        permissions: [
          {
            role: 0,
            access: false,
            redirect: "login"
          },
          {
            role: 1,
            access: true,
          },
        ],
      },
      name: "pagos",
      component: () =>
        import(
          /* webpackChunkName: "routes" */
          `@/views/licencias/Pagos.vue`
        )
    },
    {
      path: "/administracion/usuarios",
      meta: {
        permissions: [
          {
            role: 0,
            access: false,
            redirect: "login"
          },
          {
            role: 1,
            access: true,
          },
        ],
      },
      name: "supers",
      component: () =>
        import(
          /* webpackChunkName: "routes" */
          `@/views/administracion/Supers.vue`
        )
    },

    {
      path: "/administracion/errores",
      meta: {
        permissions: [
          {
            role: 0,
            access: false,
            redirect: "login"
          },
          {
            role: 1,
            access: true,
          },
        ],
      },
      name: "errores",
      component: () =>
        import(
          /* webpackChunkName: "routes" */
          `@/views/administracion/ErroresWebservice.vue`
        )
    },
    {
      path: "/catalogos/usuarios",
      meta: {
        permissions: [
          {
            role: 0,
            access: false,
            redirect: "login"
          },
          {
            role: 1,
            access: true,
          },
        ],
      },
      name: "usuarios",
      component: () =>
        import(
          /* webpackChunkName: "routes" */
          `@/views/catalogos/Usuarios.vue`
        )
    },
    {
      path: "/catalogos/articulos",
      meta: {
        permissions: [
          {
            role: 0,
            access: false,
            redirect: "login"
          },
          {
            role: 1,
            access: true,
          },
        ],
      },
      name: "articulos",
      component: () =>
        import(
          /* webpackChunkName: "routes" */
          `@/views/catalogos/Articulos.vue`
        )
    },

    {
      path: "/catalogos/ubicaciones",
      meta: {
        permissions: [
          {
            role: 0,
            access: false,
            redirect: "login"
          },
          {
            role: 1,
            access: true,
          },
        ],
      },
      name: "ubicaciones",
      component: () =>
        import(
          /* webpackChunkName: "routes" */
          `@/views/catalogos/Ubicaciones.vue`
        )
    },
    {
      path: "/catalogos/figurastransporte",
      meta: {
        permissions: [
          {
            role: 0,
            access: false,
            redirect: "login"
          },
          {
            role: 1,
            access: true,
          },
        ],
      },
      name: "figurastransporte",
      component: () =>
        import(
          /* webpackChunkName: "routes" */
          `@/views/catalogos/FigurasTransporte.vue`
        )
    },
    {
      path: "/catalogos/transportes",
      meta: {
        permissions: [
          {
            role: 0,
            access: false,
            redirect: "login"
          },
          {
            role: 1,
            access: true,
          },
        ],
      },
      name: "transportes",
      component: () =>
        import(
          /* webpackChunkName: "routes" */
          `@/views/catalogos/Transportes.vue`
        )
    },


    {
      path: "/catalogos/registros_fiscales",
      meta: {
        permissions: [
          {
            role: 0,
            access: false,
            redirect: "login"
          },
          {
            role: 1,
            access: true,
          },
        ],
      },
      name: "registros_fiscales",
      component: () =>
        import(
          /* webpackChunkName: "routes" */
          `@/views/catalogos/RegistrosFiscales.vue`
        )
    },

    {
      path: "/usuarios/change",
      meta: {
        permissions: [
          {
            role: 0,
            access: false,
            redirect: "login"
          },
          {
            role: 1,
            access: true,
          },
        ],
      },
      name: "change",
      component: () =>
        import(
          /* webpackChunkName: "routes" */
          `@/views/usuarios/Change.vue`
        )
    },


    {
      path: "/catalogos/clientes",
      meta: {
        permissions: [
          {
            role: 0,
            access: false,
            redirect: "login"
          },
          {
            role: 1,
            access: true,
          },
        ],
      },
      name: "clientes",
      component: () =>
        import(
          /* webpackChunkName: "routes" */
          `@/views/catalogos/Clientes.vue`
        )
    },
    {
      path: "/catalogos/remolques",
      meta: {
        permissions: [
          {
            role: 0,
            access: false,
            redirect: "login"
          },
          {
            role: 1,
            access: true,
          },
        ],
      },
      name: "remolques",
      component: () =>
        import(
          /* webpackChunkName: "routes" */
          `@/views/catalogos/Remolques.vue`
        )
    },
    {
      path: "/pre_carta_porte",
      meta: {
        permissions: [
          {
            role: 0,
            access: false,
            redirect: "login"
          },
          {
            role: 1,
            access: true,
          },
        ],
      },
      name: "pre_carta_porte",
      component: () =>
        import(
          /* webpackChunkName: "routes" */
          `@/views/licencias/LayoutCartaPorte.vue`
        )
    },
    {
      path: "/administracion/accesos",
      meta: {
        permissions: [
          {
            role: 0,
            access: false,
            redirect: "login"
          },
          {
            role: 1,
            access: true,
          },
        ],
      },
      name: "accesos_empresa",
      component: () =>
        import(
          /* webpackChunkName: "routes" */
          `@/views/administracion/Accesos.vue`
        )
    },

    {
      path: "/cartaporte",
      meta: {
        permissions: [
          {
            role: 0,
            access: false,
            redirect: "login"
          },
          {
            role: 1,
            access: true,
          },
        ],
      },
      name: "cartaporte",
      component: () =>
        import(
          /* webpackChunkName: "routes" */
          `@/views/licencias/CartaPorte.vue`
        )
    },

    {
      path: "/notas",
      meta: {
        permissions: [
          {
            role: 0,
            access: false,
            redirect: "login"
          },
          {
            role: 1,
            access: true,
          },
        ],
      },
      name: "notas",
      component: () =>
        import(
          /* webpackChunkName: "routes" */
          `@/views/licencias/Notas.vue`
        )
    },
    {
      path: "/newcartaporte",
      meta: {
        permissions: [
          {
            role: 0,
            access: false,
            redirect: "login"
          },
          {
            role: 1,
            access: true,
          },
        ],
      },
      name: "newcartaporte",
      component: () =>
        import(
          /* webpackChunkName: "routes" */
          `@/views/licencias/NewCartaPorte.vue`
        )
    },
    {
      path: "/reportes/cfdi",
      meta: {
        permissions: [
          {
            role: 0,
            access: false,
            redirect: "login"
          },
          {
            role: 1,
            access: true,
          },
        ],
      },
      name: "reporte_cfdi",
      component: () =>
        import(
          /* webpackChunkName: "routes" */
          `@/views/licencias/ReporteCFDI.vue`
        )
    },
    {
      path: "/newpago",
      meta: {
        permissions: [
          {
            role: 0,
            access: false,
            redirect: "login"
          },
          {
            role: 1,
            access: true,
          },
        ],
      },
      name: "newpago",
      component: () =>
        import(
          /* webpackChunkName: "routes" */
          `@/views/licencias/NewPago.vue`
        )
    },
    {
      path: "/newpagom",
      meta: {
        permissions: [
          {
            role: 0,
            access: false,
            redirect: "login"
          },
          {
            role: 1,
            access: true,
          },
        ],
      },
      name: "newpagom",
      component: () =>
        import(
          /* webpackChunkName: "routes" */
          `@/views/licencias/NewPagoM.vue`
        )
    },
    {
      path: "/newnotam",
      meta: {
        permissions: [
          {
            role: 0,
            access: false,
            redirect: "login"
          },
          {
            role: 1,
            access: true,
          },
        ],
      },
      name: "newnotam",
      component: () =>
        import(
          /* webpackChunkName: "routes" */
          `@/views/licencias/NewNotaM.vue`
        )
    },
    {
      path: "/newnota",
      meta: {
        permissions: [
          {
            role: 0,
            access: false,
            redirect: "login"
          },
          {
            role: 1,
            access: true,
          },
        ],
      },
      name: "newnota",
      component: () =>
        import(
          /* webpackChunkName: "routes" */
          `@/views/licencias/NewNota.vue`
        )
    },
    {
      path: "/reporteimpuestos",
      meta: {
        permissions: [
          {
            role: 0,
            access: false,
            redirect: "login"
          },
          {
            role: 1,
            access: true,
          },
        ],
      },
      name: "repimpuestos",
      component: () =>
        import(
          /* webpackChunkName: "routes" */
          `@/views/licencias/ReporteImpuestos.vue`
        )
    },
    {
      path: "/conteo",
      meta: {
        permissions: [
          {
            role: 0,
            access: false,
            redirect: "login"
          },
          {
            role: 1,
            access: true,
          },
        ],
      },
      name: "conteo",
      component: () =>
        import(
          /* webpackChunkName: "routes" */
          `@/views/administracion/Cuenta.vue`
        )
    },


  ]
});

// Evita el error "NavigationDuplicated" (rechazo de promesa no capturado) que
// vue-router 3.1+ lanza al navegar a la ruta actual. Se sobrescriben push y
// replace para ignorar solo ese caso y re-lanzar cualquier otro error real.
const originalPush = Router.prototype.push;
Router.prototype.push = function push(location, onResolve, onReject) {
  if (onResolve || onReject) {
    return originalPush.call(this, location, onResolve, onReject);
  }
  return originalPush.call(this, location).catch((err) => {
    if (Router.isNavigationFailure && Router.isNavigationFailure(err)) {
      return err;
    }
    if (err && err.name === 'NavigationDuplicated') {
      return err;
    }
    return Promise.reject(err);
  });
};

const originalReplace = Router.prototype.replace;
Router.prototype.replace = function replace(location, onResolve, onReject) {
  if (onResolve || onReject) {
    return originalReplace.call(this, location, onResolve, onReject);
  }
  return originalReplace.call(this, location).catch((err) => {
    if (Router.isNavigationFailure && Router.isNavigationFailure(err)) {
      return err;
    }
    if (err && err.name === 'NavigationDuplicated') {
      return err;
    }
    return Promise.reject(err);
  });
};



router.beforeEach((to, from, next) => {

  window.urlreferrer = from.path;

  NProgress.start();
  next();



})
router.afterEach((to, from) => {
  store.state.current_url = to.path;
  NProgress.done();

});

export default router;
